import { Injectable } from '@angular/core';
import {McticHttpClient, McticHttpParams, Page, Pageable} from '@mctic/ng-core';
import { Observable } from 'rxjs';
import {Identity, InformacoesProjetoVO, ProjetoConveniadoVO} from '../shared/model';

@Injectable({
  providedIn: 'root'
})
export class ProjetoConveniadoService {

  private readonly endpoint = '/sepin-backend/rest/projetos-conveniados';

  private readonly alterarDadosProjeto = '/alterar-dados-basicos-projeto';

  constructor(private readonly http: McticHttpClient) {
  }

  consultar(pageable: Pageable): Observable<Page<ProjetoConveniadoVO>> {
    const queryParams = new McticHttpParams()
      .setPageable(pageable);
    return this.http.get('/sepin-backend/rest/projetos-conveniados/query', { params: queryParams.toHttpParams()});
  }

  salvar(informacoesProjeto: InformacoesProjetoVO) {
    return this.http.post<Identity<number>>(this.endpoint, informacoesProjeto);
  }

  alterarDadosBasicosProjeto(projeto: ProjetoConveniadoVO) {
    return this.http.put(this.endpoint + this.alterarDadosProjeto, projeto);
  }

  alterar(informacoesProjeto: InformacoesProjetoVO) {
    return this.http.put(this.endpoint, informacoesProjeto);
  }
}
